module.exports = __webpack_public_path__ + "static/img/dabian.30bf10a4.png";